import { ComponentType } from 'react';
import { IBaseSuggestion } from '@bridebook/ui/src/components/bbcommon/inputs/suggestion-field/suggestion-field';
import Box from '../../../../components/fela/Box';
import truncate from '../../../../utils/truncate';
import SuggestionCustom from './suggestion-custom';
import componentsStyles from './suggestion.style';

interface IProps<TSuggestion> {
  suggestion: TSuggestion;
  supplierSuggest?: boolean;
  customSuggestion?: ComponentType<{ suggestion: TSuggestion }>;
  customSuggestLabel?: string;
}

const Suggestion = <TSuggestion extends IBaseSuggestion>({
  suggestion,
  supplierSuggest,
  customSuggestion: CustomSuggestion,
  customSuggestLabel,
}: IProps<TSuggestion>) => {
  const styles = componentsStyles();

  const { name } = suggestion;

  const CustomSuggestionBlock = () =>
    CustomSuggestion ? (
      <CustomSuggestion suggestion={suggestion} />
    ) : (
      <SuggestionCustom customSuggestLabel={customSuggestLabel} />
    );

  return suggestion.custom ? (
    <CustomSuggestionBlock />
  ) : (
    <Box style={styles.wrapper}>
      <Box style={styles.name}>{truncate(name, 27)}</Box>
      {supplierSuggest && (
        <Box style={styles.detailsWrap}>
          <Box as="span" style={styles.category}>
            {suggestion.type}
            &nbsp;
          </Box>
          <Box as="span" style={styles.town}>
            {suggestion.town}
          </Box>
        </Box>
      )}
    </Box>
  );
};

export default Suggestion;
